var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
var YourInstall = /** @class */ (function (_super) {
    __extends(YourInstall, _super);
    function YourInstall(props) {
        return _super.call(this, props) || this;
    }
    YourInstall.prototype.render = function () {
        return (React.createElement("section", { className: "content5", id: "5" },
            React.createElement("h3", null, "Professional Grade Service"),
            React.createElement("p", null, "WeatherFlow\u2019s Tempest has a revolutionary design with no moving parts, nearly zero maintenance, instant online data, free personal web page and a rich API powering a growing list of options for enhancing its beneficial impact on preparation and weather-based decision making \u2013 but it still must be installed correctly to realize all this."),
            React.createElement("p", null, "WeatherFlow has teamed with InstallerNet to ensure Tempest-owner\u2019s experiences are undiminished by improper installation, as our technicians will come prepared to mount Tempests on fences, posts, roof lines, poles/masts or chimneys by bringing the proper hardware and expertise."),
            React.createElement("p", null, "To get a risk-free custom quotation for a Tempest installation at your property, please call (800) 806-5513.  LifeTime warranties apply if you decide to schedule and get the installation.")));
    };
    return YourInstall;
}(Component));
export default YourInstall;
